export default __webpack_public_path__ + "static/windui-avatars-promo-facebook-d1e39d424380585d57eb35185979f241.png";